@if (show) {
  <div class="loading-bar-track">
    @if (mode === 'indeterminate') {
      <div class="loading-bar-fill loading-bar-fill--indeterminate"></div>
    } @else {
      <div class="loading-bar-fill" [style.width.%]="progress ?? 0"></div>
    }
  </div>
}
